import React from 'react';

import { getResponsiveImageAttributes } from '~/common';

import { Container, HeroImage } from './elements';

interface HeroProps {
  imgSrc: string;
}

export const Hero: React.FC<HeroProps> = ({ imgSrc }) => {
  const bannerImageAttributes = getResponsiveImageAttributes(imgSrc);
  return (
    <Container>
      <HeroImage {...bannerImageAttributes} />
    </Container>
  );
};
